import { StandardEvents } from '@shopify/events';

class WakeClipCartCount extends HTMLElement {
  connectedCallback() {
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate);
    window.addEventListener('pageshow', this.onPageShow);
  }

  disconnectedCallback() {
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate);
    window.removeEventListener('pageshow', this.onPageShow);
  }

  setCount(value) {
    if (Number.isInteger(value) && value >= 0) this.textContent = `(${value})`;
  }

  onCartUpdate = (event) => {
    event.promise?.then(({ cart, detail }) => {
      this.setCount(cart?.totalQuantity ?? detail?.itemCount);
    }).catch(() => {});
  };

  onPageShow = async (event) => {
    if (!event.persisted) return;
    try {
      const response = await fetch(this.dataset.cartUrl, { credentials: 'same-origin' });
      if (response.ok) this.setCount((await response.json()).item_count);
    } catch {}
  };
}

if (!customElements.get('wc-cart-count')) customElements.define('wc-cart-count', WakeClipCartCount);
